export const addDotsToRut = (input) =>
  input
    .toString()
    .split("")
    .reverse()
    .reduce((prev, curr, i) => {
      if (i > 0 && i % 3 === 0) {
        return [curr, ".", ...prev];
      }
      return [curr, ...prev];
    }, [])
    .join("");

export const formatRut = (text) => {
    const stripZero = text.replace(/^0+/, "");
    const rut = stripZero.replace(/[^kK0-9]/g, "");
    if (rut.length > 1) {
      const stripDots = rut.replace(/\./g, "");
      const stripDash = stripDots.replace(/-/g, "");
      const start = stripDash.substr(0, stripDash.length - 1);
      const verifyer = stripDash.charAt(stripDash.length - 1);
      const dotSeparated = addDotsToRut(start.replace(/[^0-9]/g, ""));
      const formatedRut = `${dotSeparated}-${verifyer}`;
      return formatedRut;
    }  
    return rut;
};
export const formatIdserial = (text) => {
    const stripZero = text.replace(/^0+/, "");
    const serial = stripZero.toUpperCase().replace(/[^A0-9]/g, "");
    if (serial.length <= 1) return serial;
    const start = serial[0];
    const rest = serial.substr(1, serial.length).replace(/[^0-9]/g, "");
    return start + rest + "";
};
export const validateRut = (input) => {
    if (input.length < 8) return false;
  
    const text = input.replace(/[^K0-9]/g, "");
    if (text.length === 0) return false;
  
    const rut = text.substring(0, text.length - 1);
    const drut = text.substring(text.length - 1);
  
    var mul = 2,
      sum = 0;
  
    for (var i = rut.length - 1; i >= 0; i--) {
      sum = sum + rut.charAt(i) * mul;
      if (mul === 7) mul = 2;
      else mul++;
    }
  
    const res = sum % 11;
    let dvr;
    switch (res) {
      case 1: {
        dvr = "K";
        break;
      }
      case 0: {
        dvr = "0";
        break;
      }
      default: {
        dvr = `${11 - res}`;
      }
    }
  
    return dvr === drut.toUpperCase();
  };

  export const onlyNumberFormatInput = (input) => {
    if (input !== null && input !== "undefined") {
      const numberWithoutFormat = input.toString().replace(/[^0-9]/g, "");
      const stripZero = numberWithoutFormat.replace(/^0+/, "");
      if (stripZero === "") return "";
      const amount = addDotsToRut(stripZero);
      return amount;
    }
    return ""
  };


  
  